import {useLocation} from 'react-router-dom';
import {useMemo} from 'react';

export function useQueryParams() {
  const location = useLocation();

  return useMemo(() => Object.fromEntries(new URLSearchParams(location?.search)), [location]);
}
